import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Address, CountryMetadata } from '@shared/models/data-model';
import { CountryService } from '@shared/services/country.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { AddressFormGroup } from './address3-helper.service';


@Component({
    selector: 'address3-form-group',
    templateUrl: './address3.component.html'
})
export class Address3Component implements OnInit, OnChanges {

    @Input()
    addressFormGroup: FormGroup<AddressFormGroup>;

    @Input()
    activeMarketsOnly: boolean = false;

    @Input()
    disableCountrySelection = false;

    @Input()
    readonly = false;

    @Input()
    translatedCountries: CountryMetadata[] = [];

    private readonly mainMarkets: string[] = ["FRA", "DEU", "ITA", "NLD", "ESP", "GBR"];
    countries: CountryMetadata[] = [];

    loading = true;

    constructor(
        private readonly countryService: CountryService
    ) { }

    get selectedCountry(): string {
        return this.addressFormGroup?.controls?.countryISO?.value;
    }

    get selectedCountryLabel(): string {
        return this.countries?.find(c => c.iso3 === this.selectedCountry)?.name;
    }

    get countryLang(): string {
        const countryMetadata = this.countries.find(c => c.iso3 === this.selectedCountry);
        return countryMetadata ? countryMetadata.lang : null;
    }

    get searchPlaceholderKey(): string {
        return this.mainMarkets.includes(this.selectedCountry) ? this.selectedCountry : "DEFAULT";
    }

    ngOnInit(): void {

        this.addressFormGroup.controls.countryISO.setValidators([
            Validators.required
        ]);
        this.addressFormGroup.controls.countryISO.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
            this.clearAddressFields(false);
        });
        this.addressFormGroup.controls.countryISO.updateValueAndValidity({emitEvent: false});
    }

    ngOnChanges(): void {
        this.setCountries(this.translatedCountries);
    }

    private clearAddressFields(emitEvent: boolean = true) {
        const fieldsToReset: Array<keyof Address> = ["line1", "line2", "city", "postalCode", "province"];
        fieldsToReset.forEach((fieldName: keyof Address) => {
            this.addressFormGroup.get(fieldName).reset(null, { emitEvent });
        });
    }

    private setCountries(allCountries: CountryMetadata[]) {
        if (!allCountries?.length) {
            return;
        }

        this.countries = allCountries
            .filter((country) => this.mainMarkets.includes(country.iso3))
            .sort(this.countryService.sortFunction)
            .concat(
                allCountries
                    .filter(country => country.activeMarket || !this.activeMarketsOnly)
                    .filter(country => !country.blacklist && !this.mainMarkets.includes(country.iso3))
                    .sort(this.countryService.sortFunction)
            );

        this.loading = false;
    }
}
